import React from 'react'

import { Box, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Button } from '@mui/material'

import type { MstCenter } from 'api-client'

interface SelectedRowInfo {
  orgCenterId: string | null
  calendarDate: any
}

interface DuplicateCenterDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  availableCenters: MstCenter[]
  selectedCenterIds: string[]
  onSelectAll: (checked: boolean) => void
  onToggleCenter: (centerId: string) => void
  selectedRow: SelectedRowInfo | null
  formatCenter: (centerId: string) => string
  formatDate: (value: any) => string
}

function DuplicateCenterDialog({
  open,
  onClose,
  onConfirm,
  availableCenters,
  selectedCenterIds,
  onSelectAll,
  onToggleCenter,
  selectedRow,
  formatCenter,
  formatDate,
}: DuplicateCenterDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="duplicate-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="duplicate-dialog-title">
        選択した設定を他のセンターに複製
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {selectedRow && (
            <Box sx={{ mb: 2 }}>
              <Box sx={{ mb: 1 }}>
                <strong>元のセンター:</strong> {formatCenter(selectedRow.orgCenterId || '')}
              </Box>
              <Box>
                <strong>日付:</strong> {formatDate(selectedRow.calendarDate)}
              </Box>
            </Box>
          )}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={availableCenters.length > 0 && selectedCenterIds.length === availableCenters.length}
                  indeterminate={selectedCenterIds.length > 0 && selectedCenterIds.length < availableCenters.length}
                  onChange={(e) => onSelectAll(e.target.checked)}
                />
              }
              label="全センター"
            />
            <Box sx={{ ml: 3, mt: 1, maxHeight: 300, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
              {availableCenters.map((c) => {
                const centerId = c.orgCenterId || ''
                return (
                  <FormControlLabel
                    key={centerId}
                    control={
                      <Checkbox
                        checked={selectedCenterIds.includes(centerId)}
                        onChange={() => onToggleCenter(centerId)}
                      />
                    }
                    label={formatCenter(centerId)}
                    sx={{ mb: 0.5 }}
                  />
                )
              })}
            </Box>
          </FormGroup>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="secondary">
          キャンセル
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="primary"
          disabled={selectedCenterIds.length === 0}
        >
          複製 ({selectedCenterIds.length})
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DuplicateCenterDialog

